import { create } from 'zustand'
import { NoticeType } from '@shared/config/notice'

interface ResultState {
  paymentMethodResult: Record<string, unknown> | null
  payStatusStore: NoticeType | null
  setPaymentMethodResult: (result: Record<string, unknown> | null) => void
  setPayStatusStore: (status: NoticeType | null) => void
  reset: () => void
}

export const useResultStore = create<ResultState>((set) => ({
  paymentMethodResult: null,
  payStatusStore: null,
  setPaymentMethodResult: (result) => set({ paymentMethodResult: result }),
  setPayStatusStore: (status) => set({ payStatusStore: status }),
  reset: () => set({ paymentMethodResult: null, payStatusStore: null }),
}))
